import dynamic from 'next/dynamic'
import React from 'react'

import Loader from '~/components/shared/Loader'

import { useGetArticleListings } from '~/services/Query/news-reviews/news-review.query'
import Paths from '~/utils/paths'

const SliderCardsSection = dynamic(
  () => import('~/components/sections/SliderCardsSection'),
  { ssr: false, loading: () => <Loader height={500} /> }
)

interface ArticleListingsProps {
  keywords: string
}

const limit = 3

const ArticleListings = ({ keywords }: ArticleListingsProps) => {
  const { data: listings, isSuccess } = useGetArticleListings({
    params: { keywords, limit },
    options: {
      enabled: !!keywords
    }
  })

  const hasListings = !!listings?.length && isSuccess
  const makeName = hasListings ? listings[0]?.make?.name : ''

  return (
    <SliderCardsSection
      unmountOnEmpty
      empty={!hasListings}
      items={listings}
      count={limit}
      title="Related Product"
      titleSize={20}
      displayLink={hasListings}
      linkHref={Paths.search.buildSearch({
        make: { name: makeName }
      })}
    />
  )
}

export default ArticleListings
